import { ActionButtonProps } from './types';
import { StyledActionButton } from './style';
import { CircularProgress, Stack } from '@mui/material';
import { createGradientOrSolid } from 'utils';

export const ActionButton: React.FC<ActionButtonProps> = ({
  text,
  action,
  font,
  colors,
  textColor,
  border = 'none',
  icon = undefined,
  width,
  borderRadius,
  marginBottom,
  className,
  isLoading,
  fontWeight,
  dataTestId = '',
  direction,
  marginRight,
  marginLeft,
}) => {
  const bgColor = colors
    ? createGradientOrSolid(colors)
    : 'var(--button-bg-color)';

  return (
    <StyledActionButton
      className={className}
      onClick={action}
      bgColor={bgColor}
      border={border}
      font={font}
      fontWeight={fontWeight}
      width={width}
      borderRadius={borderRadius}
      marginBottom={marginBottom}
      data-testid={dataTestId}
      direction={direction}
      marginRight={marginRight}
      marginLeft={marginLeft}
    >
      <Stack
        style={{ color: textColor || 'var(--button-text-color)' }}
        justifyContent="center"
        alignItems="center"
        direction="row"
        width="100%"
        gap="0.25em"
      >
        {isLoading ? (
          <CircularProgress
            sx={{
              color: 'white',
            }}
            size={20}
          />
        ) : (
          <>
            {icon && <img alt="icon" src={icon} />}
            {text}
          </>
        )}
      </Stack>
    </StyledActionButton>
  );
};
